<template>
  <div>
    <list
      row-key="PlanDtsId"
      ref="list"
      light-row
      :page="page"
      :query-params="params"
      :tempParams="tempParams"
      show-checkbox
      :show-query="showQuery"
      :get-data-func="api.getWorkDocProductPackingList"
      @row-select="onSelect"
      @check-change="onCheck"
      v-if="trendShow"
      urlHash="production/reportmanagement/prewarehousing/proLog"
      @getDataEnd="getDataEnd"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <!-- <el-tab-pane :label="'注塑任务(' + zscount + ')'" name="0"></el-tab-pane> -->
          <!-- <el-tab-pane label="特殊工艺加工生产任务" name="1"></el-tab-pane>
          <el-tab-pane label="配件装配生产任务" name="2"></el-tab-pane>
          <el-tab-pane label="产品装配生产任务" name="3"></el-tab-pane>
          <el-tab-pane label="产品组合生产任务" name="4"></el-tab-pane> -->
          <el-tab-pane v-for="(item, index) in stageList" :key="index" :label="item.StageName + '(' + item.Count + ')'" :name="item.Stage + ''"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <!-- <h2 style="font-weight: 400; color: #303133; font-size: 18px; margin-left: 5px">工单信息</h2> -->
    <!-- <info1 ref="info0" v-if="tabName == 0" style="margin-top: 20px" :data="infoData" :repData="reportData" />
    <info2 ref="info1" v-else style="margin-top: 20px" :data="infoData" :repData="reportData" /> -->
    <!-- <info3 ref="info2" v-if="tabName==2" style="margin-top: 20px;" :data="infoData"/>
    <info4 ref="info3" v-if="tabName==3" style="margin-top: 20px;" :data="infoData"/>
    <info5 ref="info4" v-if="tabName==4" style="margin-top: 20px;" :data="infoData"/> -->
    <el-tabs v-model="tabName1" type="card">
      <el-tab-pane label="入库明细" name="report">
        <!-- 报工时间，报工单重，合格重量，合格数量、不合格重量，不合格数量，明细 -->
        <el-table class="tb-c-head" :data="reportData" border>
          <el-table-column label="入库日期" prop="AddTime">
            <template slot-scope="{row}">
              {{$commonJs.toDateString(row.AddTime) }}
            </template>
          </el-table-column>
          <el-table-column label="生产批号" prop="BatchNumber" />
          <el-table-column label="存货名称" prop="ProductName" />
          <el-table-column label="存货条码" prop="BarCode" />
          <el-table-column label="产品单重" prop="Grammage" />
          <el-table-column label="合格重量(kg)" prop="Quantity2" />
          <el-table-column label="合格数量" prop="Quantity" />
          <el-table-column label="不合格重量(kg)" prop="FailQuantity2" />
          <el-table-column label="不合格数量" prop="FailQuantity" />
          <el-table-column label="装箱规格" prop="SpeciName" />
          <el-table-column label="每件数" prop="RealPackingNumber">
            <template slot-scope="{row}">
              {{row.RealPackingNumber>0?row.RealPackingNumber:''}}
            </template>
          </el-table-column>

          <el-table-column label="件数" prop="PackingQuantity">
            <template slot-scope="{row}">
              {{row.PackingQuantity>0?row.PackingQuantity:''}}
            </template></el-table-column>
     
          <el-table-column label="合格入库单" prop="DocNo" />
          <el-table-column label="不合格入库单" prop="UnDocNo" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- <report-dialog ref="editDialog"> </report-dialog>
    <report-info-dialog ref="reportInfoDialog"> </report-info-dialog> -->
  </div>
</template> 
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
// import reportDialog from '@/components/production/reportmanagement/report/toPro/reportDialog'
// import reportInfoDialog from '@/components/production/reportmanagement/report/toPro/reportInfoDialog'
import curdMixins from '@/mixins/trend/curd'

export default {
  mixins: [listMixin, curdMixins],
  components: {
    list
    //reportDialog,reportInfoDialog
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pu/plan').default,
      formApi: require('@/api/sy/formSetting').default,
      tableApi: require('@/api/sy/tableSetting').default,
      queryApi: require('@/api/sy/selectSetting').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      trendShow: true,
      params: {
        CustomerName: '',
        OrderNo: '',
        WorkDocNo: '',
        StartDate: null,
        EndDate: null,
        SourceDtsName: '',
        WorkDocType: null,
        Stage: 0,
        ToPeport: true
      },
      tabName: '0',
      tabName1: 'report',
      mode: 1,
      tempParams: {
        IsWaitIn: false,
        Stage: 0
      },
      infoData: [],
      reportData: [],
      checkList: [],
      machiningStageList: [],
      stageList: [],
      zscount: 0
    }
  },
  computed: {
    name() {
      if (this.tabName == '0') return '模具'
      if (this.tabName == '1') return '胶件'
      if (this.tabName == '2') return '配件'
      if (this.tabName == '3') return '产品'
      if (this.tabName == '4') return '产品'
      return ''
    }
  },
  created() {
    // this.machiningStageApi.list({ Status: 1, Universal: true }).then(res => {
    //   this.machiningStageList = res.Data
    // })
    this.getStageData()
  },
  mounted() {},
  methods: {
    undoOnce(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .cancelOnce({ workDocId: row.WorkDocId, planDtsId: row.PlanDtsId, reportId: row.ReportId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$refs.list.reload()
            this.$message.success(res.Msg)
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    detail(row) {
      // this.api.getReportInfo({ Id: row.ReportId }).then(res => {
      //   if (res.Code == 0) {
      //     var data = res.Data
      //     console.log(data, 'getReportInfo', this.$refs)
      //     this.$refs.reportInfoDialog.openEdit(data)
      //   }
      // })
    },
    getStageData() {
      console.log(this.$refs.list, this.$refs.list.queryParams, 'list')
      var params = { ...this.params, ...this.tempParams }
      params = this.$commonJs.obj.removeNullKey(params)
      this.api.getStagePackingList(params).then(ret => {
        this.stageList = ret.Data
      })
      // this.machiningStageApi.list({ Status: 1, Universal: true }).then(res => {
      //   this.machiningStageList = res.Data
      //   this.machiningStageList.forEach(x => {
      //     x.Count = 0
      //   })
      //   this.api.getStageList({ IsFinishReport: true }).then(ret => {
      //     this.stageList = ret.Data
      //     this.zscount = this.stageList.find(x => x.Stage == 0)?.Count
      //     this.machiningStageList.forEach(item => {
      //       var stage = this.stageList.find(x => x.Stage == item.MachiningStageId)
      //       if (stage) {
      //         item.Count = stage.Count
      //       } else {
      //         item.Count = 0
      //       }
      //     })
      //   })
      // })
    },
    reload() {
      this.$refs.list.reload()
      this.getStageData()
      // if (this.tabName === '0') {
      //   this.$refs['info0'].clear()
      // } else {
      //   this.$refs['info1'].clear()
      // }
    },
    tabClick() {
      // console.log("tab", this.tabName);
      this.infoData = []
      this.reportData = []
      // this.$refs.list.getData({ Stage: this.tabName });
      this.tempParams.Stage = Number(this.tabName)
      this.$refs.list.getData()
      this.getStageData()
      // if (this.tabName === '0') this.$refs.list.setTable(this.Injection)
      // if (this.tabName === '1') this.$refs.list.setTable(this.Special)
      // if (this.tabName === '2') this.$refs.list.setTable(this.Parts)
      // if (this.tabName === '3') this.$refs.list.setTable(this.Assembling)
      // if (this.tabName === '4') this.$refs.list.setTable(this.Combination)
      this.$emit('tabChange', this.tabName)
    },
    getDataEnd(resData) {
      this.infoData = []
      this.reportData = []
      this.getStageData()
      console.log('getDataEnd ==== resData', resData)
    },
    onSelect(row) {
      // this.$refs["info" + this.tabName].setData(row.PlanId);
      this.infoData = []
      // this.api
      //   .getWorkDocReportList({
      //     WorkDocId: row.WorkDocId,
      //     WorkDocNo: row.WorkDocNo,
      //     PlanDtsId: row.PlanDtsId
      //   })
      //   .then(res => {
      //     if (res.Data && JSON.stringify(res.Data) !== '{}') {
      //       this.infoData = [res.Data]
      //     }
      //   })
      //   .catch(err => {
      //     this.$message.error(err)
      //     // console.log(err);
      //   })
      this.api
        .getPackingList({ Id: row.WorkDocId })
        .then(res => {
          if (res.Data && JSON.stringify(res.Data) !== '{}') {
            this.reportData = res.Data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // edit(row) {
    //   var name = "edit" + this.tabName + "Dialog";
    //   this.$refs[name].openCreate({ ...row, Stage: this.tabName });
    // },
    onCheck(data) {
      this.checkList = data
    }
  }
}
</script>